import { render } from "./RSSLink.vue?vue&type=template&id=081350dd"
import script from "./RSSLink.vue?vue&type=script&lang=js"
export * from "./RSSLink.vue?vue&type=script&lang=js"

import "./RSSLink.vue?vue&type=style&index=0&id=081350dd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__